import React from "react";
import { Container, Row, Col, Form, InputGroup, Button, Card } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import "./planningtools.css";

const PlanningTools = () => {
  const tools = [
    {
      id: 1,
      name: "Kerala Wedding Photography",
      location: "Kottayam",
      rating: 5.0,
      reviews: 5,
      description:
        "Make your wedding moments shine cinematically with Kerala Wedding Photography. Founded in 2018, Kerala Wedding Photography has been dedicated to delivering unparalleled professional wedding photography and cinematography services.",
      price: "From ₹1,60,000",
      promotion: "-20%",
      image: "https://images.pexels.com/photos/1444442/pexels-photo-1444442.jpeg?auto=compress&cs=tinysrgb&w=800"
    },
    {
      id: 2,
      name: "Panda Ji Films",
      location: "Patrapada, Bhubaneswar",
      rating: 5.0,
      reviews: 2,
      description:
        "Capturing timeless moments with a cinematic touch. Panda Ji Films offers creative and professional wedding photography tailored to your style.",
      price: "From ₹80,000",
      promotion: null,
      image: "https://images.pexels.com/photos/1444442/pexels-photo-1444442.jpeg?auto=compress&cs=tinysrgb&w=800"
    }
  ];

  return (
    <Container fluid className="planning-tools-page">
      {/* Search Bar */}
      <Row className="search-bar">
        <Col md={4}>
          <InputGroup>
            <Form.Control placeholder="Search planning tools" />
          </InputGroup>
        </Col>
        <Col md={3}>
          <InputGroup>
            <Form.Control placeholder="Location" />
          </InputGroup>
        </Col>
        <Col md={2}>
          <Button variant="danger" className="find-btn">Find</Button>
        </Col>
      </Row>

      <Row>
        {/* Filters */}
        <Col md={3} className="filters">
          <h5>Special filters</h5>
          <Form.Check type="switch" label="Deals" />
          <Form.Check type="switch" label="Wedding Award Winners" className="mb-3" />
          <hr />
          <h5>1 Day Wedding Package</h5>
          <Form.Check type="checkbox" label="Under ₹25,000" />
          <Form.Check type="checkbox" label="₹25,000 - ₹49,999" />
          <Form.Check type="checkbox" label="₹50,000 - ₹74,999" />
          <Form.Check type="checkbox" label="₹75,000 - ₹99,999" />
          <Form.Check type="checkbox" label="₹1,00,000 - ₹1,24,999" />
        </Col>

        {/* Results */}
        <Col md={9}>
          {tools.map((t) => (
            <Card key={t.id} className="tool-card mb-4">
              <Row>
                <Col md={4}>
                  <Card.Img src={t.image} alt={t.name} />
                </Col>
                <Col md={8}>
                  <Card.Body>
                    <Card.Title>{t.name}</Card.Title>
                    <div className="rating">
                      <FaStar className="star-icon" /> {t.rating} ({t.reviews}) · {t.location}
                    </div>
                    <Card.Text className="description">{t.description}</Card.Text>
                    <div className="price-promo">
                      <span className="price">{t.price}</span>
                      {t.promotion && <span className="promo">{t.promotion}</span>}
                    </div>
                    <Button variant="danger" className="request-btn">
                      Request pricing
                    </Button>
                    <p className="response-time">⚡ Responds within 24 hours</p>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default PlanningTools;
